import React from 'react'
import {Modal, Button} from 'react-bootstrap'
import db from '../../database.js'
import loading from '../../img/loading.svg'
import ReactMarkdown from 'react-markdown'

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            hasAgreed: window.localStorage.getItem("agreed") === "yes",
            body:null
        };
        this.agree = this.agree.bind(this);
    }

    agree() {
        if(this.state.body) {
            window.localStorage.setItem("agreed", "yes");
            this.setState({
                hasAgreed: true
            })
        }
    }
    componentDidMount () {
        if(!this.hasAgreed) {
            db.collection('sections').doc("disclaimer").get().then((doc) => {
                this.setState({
                    body: doc.data().body
                })
            });
        }
    }

    render() {
        return (
                <Modal backdrop={'static'}
                        show={!this.state.hasAgreed}
                       bsSize={""}
                       container={this}
                >
                    <Modal.Header >
                        <Modal.Title id="contained-modal-title" >
                         Welcome to MindAid
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{    "fontSize": "16px", "fontWeight": "200"}}>
                        {(this.state.body)?<ReactMarkdown source={this.state.body}/>:<div style={{"textAlign": "center"}}><img src={loading} /></div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button bsSize="large" bsStyle="light" onClick={this.agree}>Continue</Button>
                    </Modal.Footer>
                </Modal>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Liability/index.js